import React from 'react';
import { buildColumn } from '@bingads-webui-grid/campaignui-common-columns';
import { StatusText } from '../status-with-callout';
import { BRAND_REVIEW_STATUS } from '../constants';

const defaultColumn = ({
  i18n,
  showCallout,
  hideCallout,
  timeZone,
}) => [
  {
    key: 'BrandId',
    title: i18n.getString(_TL_('Brand ID')),
    onRender: ({ BrandId }) => (<span style={{ userSelect: 'text' }}>{BrandId}</span>),
  },
  {
    key: 'BrandName',
    title: i18n.getString(_TL_('Brands')),
    helpId: 'pop_BA_BrandLists_BrandAssociations',
    onRender: (item) => {
      if (item.EditorialStatus !== BRAND_REVIEW_STATUS.REJECTED) {
        return item.BrandName;
      }
      return (
        <span className="rejected-brand">
          {item.BrandName}
        </span>
      );
    },
  },
  {
    key: 'Uri',
    title: i18n.getString(_TL_('Website')),
    helpId: 'pop_BA_BrandLists_Website',
  },
  {
    key: 'Status',
    title: i18n.getString(_TL_('Status')),
    helpId: 'pop_BA_BrandLists_Status',
    onRender: (item) => {
      if (!item || !item.BrandId) {
        return '-';
      }

      const itemId = item.BrandId;
      const itemStatus = item.EditorialStatus || BRAND_REVIEW_STATUS.APPROVED;

      return (
        <StatusText
          itemId={itemId}
          itemStatus={itemStatus}
          showCallout={() => showCallout({ itemId, itemStatus })}
          hideCallout={hideCallout}
        />
      );
    },
  },
  {
    key: 'RequestedDate',
    title: i18n.getString(_TL_('Request date')),
    helpId: 'pop_BA_BrandLists_RequestDate',
    onRender: (item) => {
      if (item.EditorialStatus !== BRAND_REVIEW_STATUS.PENDING || !item.StatusDateTime) {
        return '-';
      }
      return i18n.formatDate(new Date(item.StatusDateTime), {
        timeZone,
      });
    },
  },
];

export const buildColumns = ({
  i18n, showCallout, hideCallout, timeZone,
}) => {
  const columns = defaultColumn({
    i18n, showCallout, hideCallout, timeZone,
  });
  return columns.map(column => ({
    ...buildColumn(column),
    onRender: column.onRender || (v => v[column.key]),
  }));
};
